import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class ClientAttachmentAPI {
    public static async createNew(formData: FormData) {
        const apiRoute = ApiRoutes.clientAttachment.create;
        let image;

        try {
            image = (await ApiController.post(apiRoute, formData)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(image);
    }

    public static async getBlob(resourceUrl: string) {
        return (await ApiController.get(resourceUrl, null, true)) as AxiosResponse;
    }

    public static async getAttachmentsByClientId(clientId: string) {
        let attachments;

        try {
            attachments = (await ApiController.get(
                ApiRoutes.clientAttachment.getAttachmentsByClientId(clientId)
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(attachments);
    }

    public static async getById(attachmentId: string) {
        let attachment;

        try {
            attachment = (await ApiController.get(ApiRoutes.clientAttachment.getById(attachmentId))) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(attachment);
    }

    public static async delete(attachmentId: string) {
        try {
            await ApiController.delete(ApiRoutes.clientAttachment.delete(attachmentId));
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve();
    }
}
